export default __webpack_public_path__ + "static/media/Map.ab75a934.png";